import { promiseActionFactory } from "@teroneko/redux-saga-promise";
import { createAction } from "@reduxjs/toolkit";

import { createActionTypes } from "utils/store";

export const AUTH_REDUCER = 'auth'

const AUTH_ACTIONS = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  SET_AUTH_INFO: 'SET_AUTH_INFO',
};

const actionTypes = createActionTypes(AUTH_REDUCER, AUTH_ACTIONS)

export interface LoginData {
  username: string,
  password: string,
}

export interface AuthInfo {
  token: string,
  refreshToken?: string
}

export const loginAction = promiseActionFactory<AuthInfo>().create<LoginData>(actionTypes.LOGIN)
export const setAuthInfoAction = createAction<AuthInfo>(actionTypes.SET_AUTH_INFO)
export const logoutAction = createAction(actionTypes.LOGOUT)